

export default {
  locale: 'mk',
  Pagination: {
    items_per_page: '/ стр',
    jump_to: 'Оди на',
    jump_to_confirm: 'потврди',
    page: '',
    prev_page: 'Претходна страница',
    next_page: 'Наредна страница',
    prev_5: 'Претходни 5 страници',
    next_5: 'Наредни 5 страници',
    prev_3: 'Претходни 3 страници',
    next_3: 'Наредни 3 страници',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Избери датум',
      rangePlaceholder: ['Од датум', 'До датум'],
      locale: 'mk_MK',
      today: 'Денес',
      now: 'Сега',
      backToToday: 'Назад до денес',
      ok: 'ОК',
      clear: 'Избриши',
      month: 'Месец',
      year: 'Година',
      timeSelect: 'Избери време',
      dateSelect: 'Избери датум',
      monthSelect: 'Избери месец',
      yearSelect: 'Избери година',
      decadeSelect: 'Избери деценија',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Претходен месец (PageUp)',
      nextMonth: 'Нареден месец (PageDown)',
      previousYear: 'Претходна година (Control + left)',
      nextYear: 'Наредна година (Control + right)',
      previousDecade: 'Претходна деценија',
      nextDecade: 'Наредна деценија',
      previousCentury: 'Претходен век',
      nextCentury: 'Нареден век'
    },
    timePickerLocale: {
      placeholder: 'Избери време'
    }
  },
  TimePicker: {
    placeholder: 'Избери време'
  },
  Calendar: {
    lang: {
      placeholder: 'Избери датум',
      rangePlaceholder: ['Од датум', 'До датум'],
      locale: 'mk_MK',
      today: 'Денес',
      now: 'Сега',
      backToToday: 'Назад до денес',
      ok: 'ОК',
      clear: 'Избриши',
      month: 'Месец',
      year: 'Година',
      timeSelect: 'Избери време',
      dateSelect: 'Избери датум',
      monthSelect: 'Избери месец',
      yearSelect: 'Избери година',
      decadeSelect: 'Избери деценија',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Претходен месец (PageUp)',
      nextMonth: 'Нареден месец (PageDown)',
      previousYear: 'Претходна година (Control + left)',
      nextYear: 'Наредна година (Control + right)',
      previousDecade: 'Претходна деценија',
      nextDecade: 'Наредна деценија',
      previousCentury: 'Претходен век',
      nextCentury: 'Нареден век'
    },
    timePickerLocale: {
      placeholder: 'Избери време'
    }
  },
  global: {
    placeholder: 'Ве молиме означете'
  },
  Table: {
    filterTitle: 'Мени за филтрирање',
    filterConfirm: 'ОК',
    filterReset: 'Избриши',
    selectAll: 'Одбери страница',
    selectInvert: 'Инвертирај страница'
  },
  Modal: {
    okText: 'ОК',
    cancelText: 'Откажи',
    justOkText: 'ОК'
  },
  Popconfirm: {
    okText: 'ОК',
    cancelText: 'Откажи'
  },
  Transfer: {
    searchPlaceholder: 'Пребарај тука',
    itemUnit: 'предмет',
    itemsUnit: 'предмети'
  },
  Upload: {
    uploading: 'Се прикачува...',
    removeFile: 'Избриши фајл',
    uploadError: 'Грешка при прикачување',
    previewFile: 'Прикажи фајл',
    downloadFile: 'Преземи фајл'
  },
  Empty: {
    description: 'Нема податоци'
  },
  Icon: {
    icon: 'Икона'
  },
  Text: {
    edit: 'Уреди',
    copy: 'Копирај',
    copied: 'Копирано',
    expand: 'Зголеми'
  },
  PageHeader: {
    back: 'Назад'
  }
};
